/* eslint-disable react-hooks/exhaustive-deps */
import useFunnelDashboard from "~pages/Funnel/hooks/useFunnelDashboard";

import React, { useEffect, useMemo, useRef, useState } from "react";
import FunnelDashboardAccordion from "./components/DashboardAccordion";
import FunnelDashboardTable from "./components/DashboardTable";
import ResponseAlert from "~components/Form/components/ResponseAlert";
import { useNavigate, useParams } from "react-router-dom";
import "~services/utils/utils";
import { convertStringInDate, slug } from "~services/GlobalServices";
import useParametros from "~/fetchs/useParametros";
import useFunilObraGrupoProduto from "~/fetchs/useFunilObraGrupoProduto";
import useFunilObraProduto from "~/fetchs/useFunilObraProduto";
import useFunilStatus from "~/fetchs/useFunilStatus";
import useFunilStatusGrupo from "~/fetchs/useFunilStatusGrupo";
import { groupByKey, utils } from "~pages/Funnel/utils";
import useFunnelClientDashboard from "~pages/Funnel/hooks/useFunnelClientDashboard";
import useUpdateData from "~pages/Funnel/hooks/useUpdateData";
import { Spinner } from "@chakra-ui/react";
import useFunnelActiveWorks from "~pages/Funnel/hooks/useFunnelActiveWorks";

const FunnelDashboardContent = ({
  workFinished,
  orderFilter,
  setShowSubmit,
  setLabelButton,
  funisObra,
  setFunilStatusObj,
  table,
  funisConsolidados,
  obrasAtivas,
  filters,
  ativas,
  loading,
  setModalMessage,
  dashFilterGanha
}) => {
  const formikRef = useRef();
  const navigate = useNavigate();

  const { parameter: clienteId } = useParams();

  const { funilObraGruposProduto } = useFunilObraGrupoProduto({ formikRef });
  const { funilObraProdutos } = useFunilObraProduto({ formikRef });
  
  const { funilStatusList, funilStatusObj } = useFunilStatus(formikRef);
  const { funilStatusGrupoList } = useFunilStatusGrupo(formikRef);

  useEffect(() => {
    if(typeof clienteId == "string" && (clienteId == "undefined" || isNaN(clienteId)))
      navigate(`${utils.modulePath}/dashboard`);
  }, []);

  const deParaKey = ({
    'grupo_nome': 'grupoNome',
    'etapa': 'etapa',
    'proxima_negociacao': 'dataNegociacao'
  })

  const verificaDataProximaNegociacao = (value) => {
    let erro = false;
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    value.map((item) => {
      const proximaNegociacao = convertStringInDate(item.dataNegociacao);
      if (!erro) erro = proximaNegociacao < today;
    });
    return erro;
  };

  const lastStatusProdutos = (produtos) => {
    if ((produtos || []).length > 0) {
      const grupoStatus = (funilStatusGrupoList || []).find(funilStatusGrupo => {
        let regra = false;
        const statusRegra = (funilStatusGrupo.funilStatusIncluidosGrupo || []).map(statusIncluido => statusIncluido.funilStatusId);

        if (funilStatusGrupo.verificarTodos) {
          regra = (produtos || []).every(sku => statusRegra.includes(sku.funilStatusId));
        } else {
          regra = (produtos || []).reduce((acc, sku) => {
            if (statusRegra.includes(sku.funilStatusId)) {
              statusRegra.splice(statusRegra.indexOf(sku.funilStatusId), 1);
            }
            acc = (!statusRegra.length);
            return acc;
          }, false);
        }

        return regra;
      });

      return grupoStatus?.status || null;
    }
    return null;
  };

  const [productsGrouped, setProductsGrouped] = useState([]);
  const [hook, setHook] = useState(0);
  const [show, setShow] = useState(true);
  const updateHook = () => setHook((prev) => prev + 1);
  const { handleVolumeUpdate, handleNegociacaoUpdate, handleUpdateAllData, handleUpdateAllEtapa, handleDelete } = useUpdateData({ 
    updateHook,
    table,
    clienteId,
    setModalMessage,
    dashFilterGanha
  });

  const { convertProductFromClientToTable } = useFunnelClientDashboard({
    workFinished,
    orderFilter,
    isObra: ativas,
    lastStatusProdutos,
    handleVolumeUpdate,
    handleNegociacaoUpdate,
    handleUpdateAllData,
    handleUpdateAllEtapa,
    verificaDataProximaNegociacao,
  });

  const { convertProductToTable } = useFunnelDashboard({
    workFinished,
    lastStatusProdutos,
    handleVolumeUpdate,
    verificaDataProximaNegociacao,
    handleUpdateAllData
  });

  const { convertProductFromWorksToTable } = useFunnelActiveWorks({});

  const getFunilNaoSalvo = (dados) => {
    let data = (dados || []).map((el) => {
      const grupoProduto = (funilObraGruposProduto || []).find((gp) => gp.id === (el.funilObraGrupoProdutoId));
      const produto = (funilObraProdutos || []).find((p) => p.id === (el.funilObraProdutoId));

      return {
        id: el.id,
        clienteId: el.clienteId,
        codigoCliente: el.codigoCliente,
        label: `${el.codigoCliente} - ${el.razaoSocial}`,
        nome: el.razaoSocial,
        dataNegociacao: el.dataNegociacao,
        funilObraGrupoProdutoId: el.funilObraGrupoProdutoId,
        funilObraProdutoId: el.funilObraProdutoId,
        grupoNome: grupoProduto?.nome,
        produtoNome: produto?.nome,
        volumeEstimado: el.volumeEstimado,
        etapa: el.etapa,
        etapaSlug: el.etapaSlug ?? slug(el.etapa),
        status: funilStatusList?.find((opt) => opt.id == el.funilStatusId)?.nome ?? "Não Salvo",
      };
    });

    if (filters.dataNegociacao === "asc") {
      data.sort(function (a, b) {
        return new Date(b.dataNegociacao) - new Date(a.dataNegociacao);
      });
    } else {
      data.sort(function (a, b) {
        return new Date(a.dataNegociacao) - new Date(b.dataNegociacao);
      });
    }

    return data;
  };

  useEffect(() => {
    if (!show) setProductsGrouped([]);

    if (!ativas) {
      if(funisObra?.length){
        setProductsGrouped(getFunilNaoSalvo(funisObra));
      }
      else 
        setShow(false);
    } else {
      const dados = obrasAtivas;
      if (dados && dados.length > 0) {
        const formatedData = dados.filter(e => e.funilObraGrupoProduto).map(e => {
          return {
            id: e.id,
            clienteId: e.clienteId,
            grupoNome: e.funilObraGrupoProduto?.nome,
            codigoCliente: e.codigoCliente,
            volumeNegociado: e.volumeEstimado,
            volumeContratado: e.volumeContratado,
            status: e.funilStatus?.nome,
            obraAtiva: true
          };
        })

        setProductsGrouped(formatedData)        
      }
    }
  }, [funilObraGruposProduto, funilObraProdutos, orderFilter, hook]);

  useEffect(() => {
    if(funisObra){
      updateHook();
    }
  }, [funisObra])

  useEffect(() => {
    if(funilStatusObj && Object.entries(funilStatusObj)?.length){
      setFunilStatusObj(funilStatusObj);
    }
  }, [funilStatusObj])

  const pesquisa = useMemo(() => {

    if(!ativas){
      if(!funisConsolidados){
        if(['etapa','grupo_nome'].includes(orderFilter.value)){
          const products_grouped = groupByKey(productsGrouped, deParaKey[orderFilter.value]);
      
          return convertProductFromClientToTable(products_grouped);
        }else{ 
          //ELSE EXPLICADO
          //DATA DE NEGOCIAÇÃO
          //FOI NECESSÁRIA A INSERÇÃO DE GRUPOS QUE NÃO FAZEM PARTE DA DATA EM SI
          //POIS HÁ A CHANCE DE GRUPO/ETAPA TER A DATA DIFERENTE DE GRUPO/ETAPA/SKU
          const leadersByGroupStep = {};
          const skusByKey = {};

          productsGrouped.forEach(e => {
            const groupKey = `${e.etapa}-${e.funilObraGrupoProdutoId}`;

            if (!e.funilObraProdutoId) {
              if (!leadersByGroupStep[groupKey]) {
                leadersByGroupStep[groupKey] = e;
              }
            } else {
              skusByKey[groupKey] ??= [];
              skusByKey[groupKey].push(e);
            }
          });

          let groupedByDate = {};

          Object.entries(groupByKey(productsGrouped, "dataNegociacao")).forEach(([key, value]) => {
            // Inicializa o agrupamento para a chave atual
            groupedByDate[key] = value.reduce((acc, e) => {
              const stepKey = `${e.etapa}-${e.funilObraGrupoProdutoId}`;
              const productKey = e.funilObraProdutoId ? `${stepKey}-${e.funilObraProdutoId}` : stepKey;
          
              if (e.funilObraProdutoId) {
                const leader = leadersByGroupStep[stepKey];
                if (leader) {
                  acc[stepKey] = { ...leader, keep: true };
                }
              } else {
                if(!e.keep){
                  e.remove = (skusByKey[stepKey]?.every(el => el.dataNegociacao !== e.dataNegociacao)) ?? false;
                }
              }
          
              if(!e.remove){
                acc[productKey] = { ...e };
              }
              return acc;
            }, {});

            // Ordena os itens agrupados
            groupedByDate[key] = Object.values(groupedByDate[key]).sort((a, b) => {
              const keyDate = new Date(key).getTime();
              const dateA = new Date(a.dataNegociacao).getTime();
              const dateB = new Date(b.dataNegociacao).getTime();
          
              return dateA === keyDate ? -1 : dateB === keyDate ? 1 : dateA - dateB;
            });

            if(groupedByDate[key]?.length == 0)
              delete groupedByDate[key];
          });

          return convertProductFromClientToTable(groupedByDate);
        }
      }
  
      return convertProductToTable(groupByKey(productsGrouped, "dataNegociacao"));
    }else{
      return convertProductFromWorksToTable(groupByKey(productsGrouped, "grupoNome"));
    }
  }, [productsGrouped, ativas]);

  useEffect(() => {
    if (!clienteId) {
      setLabelButton(!clienteId ? "Salvar" : "Atualizar");
    }

    setShowSubmit(true);
  }, [clienteId]);

  const error = useMemo(() => {
    const ha = (pesquisa || []).find((el) => el.error);
    return ha;
  }, [pesquisa]);

  return (
    <div className="dashboard-content">
      {loading ? (
        <div className="flex items-center justify-center w-full p-8">
        <Spinner thickness="4px" speed="0.65s" emptyColor="gray.200" color="brand.main" size="xl" />
      </div>
      ) : 
        (
          <>
          <ResponseAlert status="error" text="Existem Obras com Negociação no Passado!" show={error} />
          {(pesquisa || []).map((group, index) => {
            return (
              <FunnelDashboardAccordion
                error={group.error}
                key={index}
                header={
                  group.accordion_header.table_layout ? (
                    <FunnelDashboardTable data={group.accordion_header.table_data} />
                  ) : (
                    group.accordion_header
                  )
                }
              >
                {/* GRUPO DE PRODUTO (LISTAGEM DOS HEADERS) E ETAPA (LISTAGEM DOS HEADERS)*/}
                <FunnelDashboardTable
                  data={group.accordion_body.data}
                  headerValues={group.accordion_header}
                  layoutData={{
                    filter: orderFilter.value,
                    isGroup: orderFilter.value == "grupo_nome",
                    isEtapa: group.accordion_body.sub?.is_accordion && orderFilter.value == "etapa"
                  }}
                  handleDelete={handleDelete}
                />
    
                {group.accordion_body.sub?.is_accordion && group.accordion_body.sub?.body?.rows?.length > 0 ? (
                  <FunnelDashboardAccordion 
                    headerVariation={group.accordion_body.sub?.show_more_header ? "show-more" : ""}
                    // alwaysActived={orderFilter.value == "proxima_negociacao"}
                  >
                    {(group.accordion_body.sub?.accordion_header || []).map((el, index) => {
                      return (
                        <FunnelDashboardAccordion
                          key={index}
                          header={
                            <FunnelDashboardTable
                              data={{ header: el }}
                              headerValues={el}
                              isGroup={true}
                              handleDelete={handleDelete}
                            />
                          }
                          accordioncfg={{
                            disable_accordion: el?.sub?.body?.rows?.length === 0,
                            close_accordion:el?.sub?.body?.rows?.length === 0
                          }}
                        >
                          {/* ESSE TRÁS OS ITENS DO TERCEIRO TIPO DA HIERARQUIA */}
                          <FunnelDashboardTable
                            variation="secundary"
                            isEtapa={true}
                            data={el.sub}
                            handleDelete={handleDelete}
                          />
                        </FunnelDashboardAccordion>
                      )}
                    )}
                  </FunnelDashboardAccordion>
                ) : (
                  group?.accordion_body?.sub?.body?.rows?.length > 0 ? (    
                    // GRUPO DE PRODUTO (LISTAGEM DE SUBITENS)
                    <FunnelDashboardAccordion headerVariation={"show-more"}>
                      <FunnelDashboardTable
                        variation="secundary"
                        data={group.accordion_body.sub}
                        layoutData={{
                          filter: orderFilter.value
                        }}
                        handleDelete={handleDelete}
                      />
                    </FunnelDashboardAccordion>
                  ) : null
                )}
              </FunnelDashboardAccordion>
            );
          })}
          </>
        )
      }
    </div>
  );
};

export default FunnelDashboardContent;
